import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { fetchIngestionTime } from "./ingestionTIme.thunk";

export const ingestionSlice = createSlice({
  name: "ingestionTime",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchIngestionTime.fulfilled,
      (state, action: PayloadAction<Record<string, string>>) => {
        return action.payload;
      }
    );
  },
});

export default ingestionSlice.reducer;
